"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const material_1 = require("@mui/material");
const useCardButotnStyle = ({ greenStyle, single, disabled }) => {
    const theme = (0, material_1.useTheme)();
    const container = {
        padding: greenStyle ? '.5rem 1rem' : '12px 1rem',
        border: `1px solid ${theme.qlub.palette.dim.main}`,
        borderRadius: '8px',
        display: 'flex',
        justifyContent: 'space-between',
        cursor: !greenStyle && 'pointer',
        background: disabled ? theme.qlub.palette.dim.main : theme.qlub.palette.white.main,
        '& svg': {
            color: theme.qlub.palette.onSurfaceColors.mediumEmphasis,
        },
        '&>div:first-of-type': {
            display: 'flex',
            alignItems: 'center',
            '&>div': Object.assign({ display: 'flex', flexDirection: 'column', color: disabled && theme.qlub.palette.onSurfaceColors.disabled }, (single
                ? {
                    '& p': {
                        color: greenStyle && theme.qlub.palette.success.main,
                    },
                }
                : {
                    '& p:last-of-type': {
                        color: greenStyle && theme.qlub.palette.success.main,
                    },
                })),
            '&>span': {
                display: 'flex',
                alignItems: 'center',
                '&>svg': {
                    color: disabled
                        ? theme.qlub.palette.onSurfaceColors.disabled
                        : greenStyle
                            ? theme.qlub.palette.success.main
                            : theme.qlub.palette.onSurfaceColors.mediumEmphasis,
                },
                paddingRight: '.5rem',
            },
        },
        '&>div:last-of-type': {
            '& button': {
                padding: '4px !important',
            },
            display: 'flex',
            alignItems: 'center',
            '& svg': {
                fontSize: greenStyle ? '24px' : '16px',
                color: disabled
                    ? theme.qlub.palette.onSurfaceColors.disabled
                    : greenStyle
                        ? theme.qlub.palette.onSurfaceColors.disabled
                        : theme.qlub.palette.onSurfaceColors.mediumEmphasis,
            },
        },
    };
    return {
        container,
    };
};
exports.default = useCardButotnStyle;
